import dayjs from "dayjs";
import { IGetReportContaReceberUseCase } from "../../../presentation/useCases/read/get_report_conta_receber_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";


/**
 * GetReportContaReceberUseCase
 */

export class GetReportContaReceberUseCase implements IGetReportContaReceberUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(idContasReceber: number, requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportContaReceber(idContasReceber, requiredMimeType ?? "text/html");

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = idContasReceber === null
        ? `contas_receber_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`
        : `conta_receber_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;

  }
}
